import { Modal } from '@similarweb/ui-components';
import type { PropsWithChildren } from 'react';
import { CloseIconButton } from './StyledCampaignModal';
import { colorsPalettes } from '@similarweb/styles';
import { Close } from '@similarweb/icons';

interface ICampaignModalProps extends PropsWithChildren {
    isOpen: boolean;
    dataAutomation?: string;
    customStyles?: ReactModal.Styles;
    children: React.ReactNode;
    onClose?: () => void;
}

export const CampaignModal = ({
    isOpen,
    customStyles,
    dataAutomation,
    children,
    onClose
}: ICampaignModalProps) => {
    return (
        <Modal
            customStyles={customStyles}
            isOpen={isOpen}
            data-automation={dataAutomation}
        >
            {onClose ? (
                <CloseIconButton
                    type="flat"
                    color={colorsPalettes.midnight[50]}
                    onClick={onClose}
                    data-automation={`${dataAutomation}-close`}
                >
                    <Close
                        size="sm"
                        color={colorsPalettes.carbon[0]}
                    />
                </CloseIconButton>
            ) : null}

            {children}
        </Modal>
    );
};
